import React from "react";
import {
  ROLE_META,
  userInitials,
  userLedgerSubline,
} from "../userFloorHelpers";

export default function UserFloorRow({ user, rank, selected, onSelect, heatPct }) {
  const role = user?.role || "user";
  const roleMeta = ROLE_META[role] || { short: role, tone: "user" };
  const isBanned = Boolean(user?.isBanned);
  const isStaff = roleMeta.tone === "staff";
  const initials = userInitials(user?.name, user?.email);

  return (
    <button
      type="button"
      className={`amf-row au-user-row${selected ? " amf-row-selected" : ""}${
        isBanned ? " au-user-row-banned amf-row-action" : ""
      }${isStaff ? " au-user-row-staff" : ""}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct}%` }}
        title={isBanned ? "Banned account" : "Wallet weight"}
        aria-hidden
      />
      <span className="amf-row-rank">{String(rank).padStart(2, "0")}</span>
      <span
        className={`au-user-row-avatar au-user-row-avatar-${roleMeta.tone}`}
        aria-hidden
      >
        {initials}
      </span>
      <span className="amf-row-body au-user-row-body">
        <span className="amf-row-top au-user-row-top">
          <span className="amf-row-name" title={user?.name || "Unknown"}>
            {user?.name || "Unknown"}
          </span>
          <span className={`au-user-role au-user-role-${roleMeta.tone}`}>{roleMeta.short}</span>
          {isBanned ? <span className="amf-row-tag amf-row-tag-warn">Banned</span> : null}
        </span>
        <span className="amf-row-sub au-user-row-sub">{userLedgerSubline(user)}</span>
      </span>
    </button>
  );
}
